module.exports = __webpack_public_path__ + "assets/crime_white.3df6ebe6.svg";